module.exports = __webpack_public_path__ + "static/img/PTGL.c3f6231.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/PTGL.png
// module id = +Sby
// module chunks = 1